/**
 * Devuelve la cadena con la primera letra en mayuscula.
 * No modifica las otras letras.
 *
 * @param {string} string la cadena que vamos a capitalizar
 */
export function capitalize(string = '') {
  if (typeof string !== 'string') {
    if (string === null) {
      string = '';
    } else if (typeof string === 'number') {
      string += '';
    } else {
      throw new Error(`capitalize: el argumento no es de tipo string, es de tipo "${typeof string}"`);
    }
  }
  const str = string || '';
  return (str[0] || '').toUpperCase() + str.slice(1);
}
